import Logo from '@atom/components/common/navigation/Logo';
import { AppBar, Box, Toolbar } from '@atom/mui';
import colors from '@atom/styles/colors';
import layoutStyles from '@atom/styles/layout';

import classes from './login.module.css';

const navBarStyle = {
  height: layoutStyles.topNavHeight,
  backgroundColor: colors.neutral.white,
  boxShadow: '0 2px 4px 1px',
  color: colors.utility.boxShadow,
  position: 'fixed',
  top: 0,
};

type AuthTopBarProps = {
  prompt: string;
  ctaLabel: string;
  onCtaClick: () => void;
};

const AuthTopBar = ({ prompt, ctaLabel, onCtaClick }: AuthTopBarProps) => (
  <AppBar style={navBarStyle}>
    <Toolbar>
      <div>
        <Logo />
      </div>
      <Box sx={{ flexGrow: 1 }} />
      <div className={classes.navRightContainer}>
        <div className={classes.navRightText}>{prompt}</div>
        <div className={classes.navRightLogin} onClick={onCtaClick}>
          {ctaLabel}
        </div>
      </div>
    </Toolbar>
  </AppBar>
);

export default AuthTopBar;
